export const STATUSES = [
  { key: "nuovo", label: "Nuovo", cls: "bg-ink text-ivory" },
  { key: "contattato", label: "Contattato", cls: "bg-goldtan/30 text-ink" },
  { key: "qualificato", label: "Qualificato", cls: "bg-emerald-100 text-emerald-800" },
  { key: "scartato", label: "Scartato", cls: "bg-ink/10 text-ink/50" },
];

export const StatusBadge = ({ status }) => {
  const s = STATUSES.find((x) => x.key === status) || STATUSES[0];
  return <span className={`inline-block px-2 py-1 font-sans-ui text-[9px] tracking-mega ${s.cls}`}>{s.label.toUpperCase()}</span>;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

// ISO UTC -> value for <input type="datetime-local"> in the admin's local timezone
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
